<template>
	<div id="schools-box" :class="[orderedSchools ? 'block' : 'hidden']">
		<!-- If got schools ordered show box -->
		<button v-for="(school, key) in schools" :key="key" class="result" @click="selectSchool(school)">
			<span class="name">{{ school.title }}</span>
			<span class="street">{{ school.address }}</span>
			<a :href="'mailto:'+school.email" class="email">{{ school.email }}</a>
			<a :href="'tel:+34 '+school.phone" class="phone">
				<img src="/img/icons/phone-icon.svg"/>
				{{ school.phone }}
			</a>
			<span class="whatsapp">
				<img src="/img/icons/whatsapp-icon.svg"/>
				{{ school.phone }}
			</span>

			<div v-if="school.timetable">
				<span class="hours" @click="showHours = !showHours">
					{{ trans.viewHours }}
				</span>
				<div class="flex flex-col timetable mt-2 text-xs" :class="{ hidden: !showHours }" v-html="school.timetable"></div>
			</div>

			<a :href="trans.school + '/' + school.slug" class="discover hover:underline">
				{{ trans.discover }}
				<img src="/img/icons/icons-arrow-right-dark.svg" alt="" />
			</a>
		</button>
	</div>
</template>
<script>
export default {
	data() {
		return {
			trans: "",
			lang: window.appLocale,
			showHours: false
		};
	},
	props: {
		orderedSchools: {
			type: Boolean,
			default: false
		},
		schools: {
			type: Array,
			default: () => {
				return [];
			}
		},
		horario: {
			type: Object
		}
	},
	methods: {
		selectSchool(school, zoom = 15) {
			this.$emit("selectSchool", { school, zoom });
		}
	},
	created() {
		this.trans = window?.trans;
	}
};
</script>
